import { BasicPage } from '../../../theme/Component/BasicPage';
import { BasicTable, MASK_MONEY, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { useEffect, useState } from 'react';
import { Singleton } from '../../../../core/services/Singleton';
import { Modal } from '../../../theme/Component/Modal';
import { ListMenu } from '../../../theme/Component/ListMenu';
import { MyEditor } from '../../../theme/Component/MyEditor';
import { CompanyEditor } from '../Company/CompanyEditor';
import { OfficeEditor } from '../Office/OfficeEditor';
import { BankService } from './CashDeskAccount-Service';
import { toast } from 'react-toastify';
import { AccountEditor } from '../../../editor/AccountEditor';
import { ModalConfirm } from '../../../theme/Component/ModalConfirm';
import { SelectAccountantTree } from '../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree';
import { PrintJson } from '../../../theme/Component/PrintJson';
import { BakingEntityEditor } from '../BankingEntity/BankingEntitySelect';
import { CashDeskAccountSelector } from './CashDeskAccountSelector';
import { BasicSwitch } from '../../../theme/Component/BasicSwitch';
import { SelectBusinessCore } from '../BusinessCore/SelectBusinessCore';
import { CashDeskCDP } from './CashDeskAccountCDP/CashDeskCDP';
import { AccountantConceptEditor } from '../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/AccountantConcept/AccountantConceptEditor';
import { SelectAccountantConcept } from '../../../contract/etapa-contrato/contrac/ublinvoice/SelectAccountantConcept';
import { AccountantConceptEditorCatalog } from '../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/AccountantConcept/AccountantConceptEditorCatalog';


export const CashDeskAccount = () => {

    const single = Singleton.getInstance()
    const [bean, setBean] = useState<any>({});
    const [lista, setLista] = useState<any>([]);
    const [conpany, setCompany] = useState<number>(null);
    const [office, setOffice] = useState<number>(null);
    const [modalcdp, setModalcdp] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const service = new BankService();
    const idBean = 'IDCashDeskAccount';

    const head = [
        { title: 'ID', property: idBean, mask: MASK_NUMBER },
        { title: 'Nombre', property: 'Name' },
        { title: 'Responsable de la Caja', property: 'AccountName' },
        { title: 'Unidad de Negocio', property: 'BusinessCoreName', visible: true },
        { title: 'Concepto para Registro de Reembolso de Terceros', property: 'AccountantConceptName', visible: true },
        // { title: 'Cuenta Contable Anticipo a Terceros', property: 'ThirdAdvanceAccountantIDStrName', visible: true },
        { title: 'Valor de la Base', property: 'BaseValue', mask: MASK_MONEY },
        { title: 'Caja Destino', property: 'DestinityCash' },
        { title: 'Cuenta Contable', property: 'AccountantIDName' },
        { title: 'Creado por', property: 'EmployeeName' },
        { title: 'Oficina a la que pertenece', property: 'OfficeName' },
        { title: 'Utilizar Cuenta Transitoria para Movimientos de Caja', property: 'UseTransitAccountantIDForCashOps' },
        { title: 'Utiliza Presupuesto', property: 'UseBudget' },
        { title: 'No Contabilizar Movimientos de Caja de Pagos/Reintegros', property: 'DontAccountantingForCashOps' },
        { title: 'Utilizar Responsable de Caja para Todos los Movimientos', property: 'UseResponsibleForAllOps' },
    ]

    const setRowBean = (bean: any) => {
        setBean(bean);
        //console.log(bean)
    }

    // useEffect(() => {
    //     setBean({ ...bean, 'IDOffice': office })

    //     if (office != null && !isNaN(office)) {
    //         ////console.log(office);
    //         getLista();
    //     }
    // }, [conpany])
    useEffect(() => {
        setBean({ ...bean, 'IDOffice': office })

        if (office != null && !isNaN(office)) {
            ////console.log(office);
            getLista();
        }
    }, [office])

    const getLista = () => {
        service.spinON();
        service.getCashDeskAccountCatalog(office, null).subscribe(
            (resp: any) => {
                if (resp.DataBeanProperties.ErrorMessage) {
                    toast.error(resp.DataBeanProperties.ErrorMessage);
                }
                else if (resp.DataBeanProperties.ObjectValue) {
                    setLista(resp.DataBeanProperties.ObjectValue);
                }
                service.spinOFF();
            }
        )
    }

    const eliminarItem = () => {
        service.spinON();
        //console.log(bean.IDCashDeskAccount)
        service.deleteCashDeskAccount(bean.IDCashDeskAccount).subscribe(
            (resp: any) => {
                service.spinOFF();
                if (resp) {
                    getLista();
                }
                single.delete(bean.IDCashDeskAccount, bean);
            }
        );
        setModalConfirm({ ...modal, "view": false });
    }

    const updateItem = () => {
        service.spinON();
        service.updateCashDeskAccount(bean).subscribe((resp: any) => {
            service.spinOFF();
            if (resp.DataBeanProperties.ObjectValue) {
                getLista();
            }
            single.update(bean);
        });
        setModal({ ...modal, "view": false });
        ////console.log(bean);
    };

    const agregarItem = () => {
        let b = {
            BaseValue: 0,
            IDOffice: office,
            IDEmployee: single.getAccountID(),
        };
        setBean(b);
        setModal({ ...modal, "view": true, name: "Agregar" });
    };

    const iconButtonsItem = [
        { nombre: "Agregar", visible: single.canCreate(), icono: "ri-file-add-line", evento: agregarItem },
    ];

    const listaBotones = () => {
        const botones = [
            { titulo: "Consultar CDPs asociados a la Caja Menor", icono: "ri-file-list-line", visible: single.canEdit(), evento: () => { setModalcdp({ ...modalcdp, view: true, name: "Editar" }); }, },
            { titulo: "Editar", icono: "ri-file-list-line", visible: single.canEdit(), evento: () => { setModal({ ...modal, view: true, name: "Editar" }); }, },
            { titulo: "Eliminar", icono: "ri-file-user-line", visible: single.canDelete(), evento: () => { setModalConfirm({ ...modalConfirm, view: true, name: `Eliminar ${bean.Name}` }); }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    return (
        <BasicPage titulo='Cajas Menores'>
            <div className="row">
                <div className="col-6">
                    <CompanyEditor id={conpany} onchange={(e: any) => { setCompany(e); }}></CompanyEditor>
                </div>
                <div className="col-6">
                    <OfficeEditor key={conpany} id={office} idconpany={conpany} onchange={(e: any) => { setOffice(e) }}></OfficeEditor>
                </div>
            </div>
            <div className="row mt-3">
                {office ?
                    <>
                        <div className="col">
                            <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setRowBean} ></BasicTable>
                            <Modal modal={modalcdp} updateModal={setModalcdp} >
                                <div className="row">
                                    <div className="col-md-12">
                                        <CashDeskCDP idCashDeskAccount={bean.IDCashDeskAccount} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                    </>
                    :
                    <>
                        <div className="alert alert-warning text-center">
                            Debe seleccionar una oficina
                        </div>
                    </>
                }
            </div>

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modal} updateModal={setModal} eventModal={updateItem}>
                <div className="row">
                    <div className="col-md-6">
                        <label >Nombre:</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, "Name": e.target.value }); }} />
                    </div>
                    <div className="col-md-6">
                        <SelectAccountantTree label='Cuenta Débito' jsonCode={bean.AccountantIDStr} onChange={(e) => { setBean({ ...bean, "AccountantIDStr": e.JsonCode }) }} />
                    </div>
                    <div className="col-md-6">
                        <AccountEditor idAccount={bean.IDAccount} label='Responsable de la Caja:' onChange={({ IDAccount }: any) => { setBean({ ...bean, "IDAccount": IDAccount }) }} />
                    </div>
                    <div className="col-md-6">
                        <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e.IDBusinessCore, "BusinessCoreCodeName": `${e.Code} - ${e.Name}` }) }} />
                    </div>
                    {/* <div className="col-md-6">
                        <SelectAccountantTree label='Cuenta Contable Anticipo a Terceros' jsonCode={bean.ThirdAdvanceAccountantIDStr} onChange={(e) => { setBean({ ...bean, "ThirdAdvanceAccountantIDStr": e.JsonCode }) }} />
                    </div> */}
                    <div className="col-md-6">
                        {/* <SelectAccountantConcept label='Concepto de Ingreso de Facturación' idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, "IDAccountantConcept": e}) }} /> */}
                        <AccountantConceptEditorCatalog label="Concepto para Registro de Reembolso de Terceros" render={bean.AccountantConceptName} idSelector={bean.IDAccountantConcept} onChange={(e) => { setBean({ ...bean, 'IDAccountantConcept': e.IDAccountantConcept, "AccountantConceptName": e.Name }) }} returnType="Object" />
                    </div>
                    <div className="col-md-6">
                        <label >Valor de la Base:</label>
                        <input type="number" className="form-control" value={bean.BaseValue} onChange={(e) => { setBean({ ...bean, "BaseValue": e.target.value }); }} />
                    </div>
                    <div className="col-md-6">
                        {/* <input type="number" className="form-control" value={bean.DestinityCash} onChange={(e) => { setBean({ ...bean, "DestinityCash": e.target.value }); }} /> */}
                        <CashDeskAccountSelector id={bean.DestinityCash} onchange={(e) => { setBean({ ...bean, "DestinityCash": e }) }} label='Caja Destino' />
                    </div>
                    <div className="col-md-6">
                        <BakingEntityEditor label='Banco de destino' idSelector={bean.DestinityBank} onChange={(e) => { setBean({ ...bean, "DestinityBank": e }); }} />
                    </div>
                    <div className="col-md-6 mt-2">
                        <BasicSwitch estado={bean.UseBudget} label="Utiliza Presupuesto ?" eventChange={(e: any) => {
                            setBean({ ...bean, "UseBudget": e })
                        }}></BasicSwitch>
                    </div>
                    <div className="col-md-6 mt-2">
                        <BasicSwitch estado={bean.UseTransitAccountantIDForCashOps} label="Utilizar Cuenta Transitoria para Movimientos de Caja?" eventChange={(e: any) => {
                            setBean({ ...bean, "UseTransitAccountantIDForCashOps": e })
                        }}></BasicSwitch>
                    </div>
                    <div className="col-md-6 mt-2">
                        <BasicSwitch estado={bean.DontAccountantingForCashOps} label="No Contabilizar Movimientos de Caja de Pagos/Reintegros" eventChange={(e: any) => {
                            setBean({ ...bean, "DontAccountantingForCashOps": e })
                        }}></BasicSwitch>
                    </div>
                    <div className="col-md-6 mt-2">
                        <BasicSwitch estado={bean.UseResponsibleForAllOps} label="Utilizar Responsable de Caja para Todos los Movimientos?" eventChange={(e: any) => {
                            setBean({ ...bean, "UseResponsibleForAllOps": e })
                        }}></BasicSwitch>
                    </div>
                </div>
            </Modal>
        </BasicPage>
    )
}